export const emptyPage = () => ({
  data: [],
  current_page: 1,
  last_page: 1,
  total: 0,
});

export const emptyResource = () => ({
  data: emptyPage(),
  loading: false,
  loaded: false,
  error: "",
});

export const emptyRecentResource = () => ({
  data: [],
  period: null,
  loading: false,
  loaded: false,
  error: "",
});

export const toLocalInput = (value) =>
  value ? new Date(value).toISOString().slice(0, 16) : "";

export const pageFromResponse = (response) => {
  const value = response && response.data ? response.data : response;
  if (Array.isArray(value))
    return { ...emptyPage(), data: value, total: value.length };
  if (!value || typeof value !== "object") return emptyPage();
  if (Array.isArray(value.data)) return { ...emptyPage(), ...value };
  if (value.data && Array.isArray(value.data.data))
    return { ...emptyPage(), ...value.data };
  return emptyPage();
};

export const transactionPageFromResponse = (response) => {
  const grouped = response && response.data ? response.data : {};
  const rows =
    grouped && typeof grouped === "object"
      ? Object.keys(grouped).reduce((items, key) => {
          const group = Array.isArray(grouped[key]) ? grouped[key] : [];
          return items.concat(group);
        }, [])
      : [];
  const total = Number(
    response && response.total ? response.total : rows.length,
  );
  const currentPage = Number(
    response && response.current_page ? response.current_page : 1,
  );
  return {
    data: rows,
    current_page: currentPage,
    last_page: Math.max(1, Math.ceil(total / 10)),
    total,
  };
};
